// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"JigPreview_previewContainer__3mWYJ"};